import React, { useEffect, useState } from 'react'
import {FSDprojects , MEprojects , CSSprojects} from '../../data/projectsData'

import CardCSS from '../../components/cardCSS/cardCSS'
import CardFSD from '../../components/cardFSD/cardFSD'
import CardME from '../../components/cardME/cardME'


import { Fade} from 'react-animated-components'

import EngineeringIcon from '@mui/icons-material/Engineering';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import ColorLensIcon from '@mui/icons-material/ColorLens';

import './ProjectPage.css'

export default function ProjectsPage() {
  const [btnClick,setBtnClick] = useState('');

  useEffect(()=>{
    setBtnClick(JSON.parse(localStorage.getItem("BtnClick")) || "FSD")
  },[])

  useEffect(()=>{
    localStorage.setItem("BtnClick", JSON.stringify(btnClick))
  },[btnClick])

  return (
    <Fade
      ref={{
        current: '[Circular]'
      }}
      onActive={function noRefCheck(){}}
      onComplete={function noRefCheck(){}}
    >
      <div className='ProjectPage'>
        <div className='ProjectTitle'>
          <h2>
            My <span>Projects</span>
          </h2>
        </div>
        <div className='ProjectPageBtns'>
          <DeveloperModeIcon fontSize='large' className={`ProjectPageIcon ${btnClick==='FSD' ? 'ProjectPageIconActive' : null }`} onClick={(e)=>{ e.preventDefault(); setBtnClick('FSD');}}/>
          <EngineeringIcon fontSize='large' className={`ProjectPageIcon ${btnClick==='ME' ? 'ProjectPageIconActive' : null }`} onClick={(e)=>{ e.preventDefault(); setBtnClick('ME');}}/>
          <ColorLensIcon fontSize='large' className={`ProjectPageIcon ${btnClick==='CSS' ? 'ProjectPageIconActive' : null }`} onClick={(e)=>{e.preventDefault(); setBtnClick('CSS');}}/>
        </div>
        <div className='ProjectPageContainer'>
          {
            btnClick === 'FSD' 
            ? 
              (
                FSDprojects.map((project)=>(
                    <CardFSD name={project.projectName} demo={project.projectLink} code={project.codeLink} picture={project.projectPicture} tags={project.projectTags} description={project.projectDiscription} key={project.projectID}/>
                ))
              )
            : 
            btnClick === 'ME' 
            ? 
              (
                MEprojects.map((project)=>(
                    <CardME name={project.projectName} video={project.projectVideo} picture={project.projectPicture} tags={project.projectTags} description={project.projectDiscription} key={project.projectID}/>
                ))
              ) 
            : 
            btnClick === 'CSS' 
            ? 
              (
                CSSprojects.map((project)=>(
                    <CardCSS name={project.projectName} code={project.codeLink} picture={project.projectPicture} tags={project.projectTags} description={project.projectDiscription} key={project.projectID}/>
                ))
              ) 
            : 
              null
          }
        </div>
      </div>
    </Fade>
  )
}
